export interface FormInputs {
    description: string;
    [key: number]: boolean;
}

export enum FormControl {
    Description = 'description',
}
